import { createFileRoute } from "@tanstack/react-router";
import TOTPSetup from "@/auth/totp-setup";

export const Route = createFileRoute("/(auth)/totp-setup")({
  component: TOTPSetup,
});
